import { createApi } from "@reduxjs/toolkit/query/react";

import type { QueryRow } from "../../../types/QueryRow";
import { getBaseQuery } from "../baseQuery";

export const queryService = createApi({
  reducerPath: "queryService",
  baseQuery: getBaseQuery("orpheus"),
  tagTypes: ["Query"],
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    executeQuery: builder.query<QueryRow[], { query: string }>({
      query: (data) => ({
        url: `/api/query/v2/execute`,
        method: "POST",
        body: { q: data.query },
      }),
      providesTags: [{ type: "Query", id: "LIST" }],
    }),
  }),
});

export const { useExecuteQueryQuery } = queryService;
